import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { HttpClientService } from "../../services/http-client-service";
import { HttpResponseMessage } from "aurelia-http-client";
import {
  Foerderfluessigkeit,
  TypFoerderfluessigkeit,
  ProductfinderData,
  Pumpentyp,
} from "./productfinder-data";
import { ProductfinderResult } from "./productfinder-result";
import {
  ProductfinderOfferData,
  ProductfinderOfferResult,
} from "./productfinder-offer-data";
import {
  DownloadType,
  MatrixData,
  FileNameResult,
  ProductfinderDownloadData,
} from "./productfinder-downloads-data";

@autoinject
export class ProductfinderService {
  constructor(
    private httpClientService: HttpClientService,
    private i18n: I18N,
  ) {}

  getPumpen(
    search: string,
    geraeuschoptimiert: boolean | null,
  ): Promise<Pumpentyp[]> {
    return this.get<Pumpentyp[]>(
      "productfinder/pumpen" +
        "?s=" +
        encodeURIComponent(search) +
        "&g=" +
        geraeuschoptimiert,
    );
  }

  getPumpentypen(
    search: string,
    geraeuschoptimiert: boolean | null,
  ): Promise<Pumpentyp[]> {
    return this.get<Pumpentyp[]>(
      "productfinder/pumpentyp" +
        "?s=" +
        encodeURIComponent(search) +
        "&g=" +
        geraeuschoptimiert,
    );
  }

  getFoerderfluessigkeiten(
    typ: TypFoerderfluessigkeit,
    search: string,
  ): Promise<Foerderfluessigkeit[]> {
    let typstring = TypFoerderfluessigkeit[typ];
    return this.get<Foerderfluessigkeit[]>(
      "productfinder/foerderfluessigkeit" +
        "?t=" +
        typstring +
        "&s=" +
        encodeURIComponent(search) +
        "&l=" +
        this.i18n.getLocale(),
    );
  }

  getMatrixdata(pumpentyp: string): Promise<MatrixData> {
    return this.get<MatrixData>(
      "downloads/geometrie-matrix" +
        "?s=" +
        encodeURIComponent(pumpentyp) +
        "&l=" +
        this.i18n.getLocale(),
    );
  }

  download(
    data: ProductfinderDownloadData,
    type: DownloadType,
  ): Promise<HttpResponseMessage> {
    let typstring = DownloadType[type];
    return this.httpClientService
      .get()
      .configure((h) => {
        h.withResponseType("blob");
      })
      .post("downloads/files" + "?t=" + typstring, data)
      .then((r) => (r.isSuccess ? r : Promise.reject(r)));
  }

  getDownloadFilename(
    data: ProductfinderDownloadData,
    type: DownloadType,
  ): Promise<FileNameResult> {
    let typstring = DownloadType[type];
    return this.post<FileNameResult>(
      "downloads/filename" + "?t=" + typstring,
      data,
    );
  }

  compute(data: ProductfinderData): Promise<ProductfinderResult> {
    return this.post("productfinder/compute", data);
  }

  offer(data: ProductfinderOfferData): Promise<ProductfinderOfferResult> {
    return this.post("productfinder/offer", data);
  }

  private get<T>(url: string): Promise<T> {
    return this.httpClientService
      .get()
      .configure((h) => {
        h.withResponseType("application/json");
      })
      .get(url)
      .then((r) => r.content)
      .catch((e) => {
        if (e.content) throw e.content;
        else throw e;
      });
  }

  private post<T>(url: string, data: any): Promise<T> {
    return this.httpClientService
      .get()
      .configure((h) => {
        h.withResponseType("application/json");
      })
      .post(url, data)
      .then((r) => r.content)
      .catch((e) => {
        throw {
          errorNo:
            e.headers && e.headers.has("X-Application-Error-Number")
              ? e.headers.get("X-Application-Error-Number")
              : "(unknown)",
        };
      });
  }
}
